import { render } from "./MessagePopup.vue?vue&type=template&id=24a8c2fe&scoped=true&ts=true"
import script from "./MessagePopup.vue?vue&type=script&lang=ts"
export * from "./MessagePopup.vue?vue&type=script&lang=ts"

import "./MessagePopup.vue?vue&type=style&index=0&id=24a8c2fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a8c2fe"]])

export default __exports__